import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {ProcessFlowchartConfigVersionGraphQL} from '../../../../graphql-fragments/processes/__generated/ProcessFlowchartConfigVersionGraphQL';
import {AccessibleFlowchartConfigVersion} from './FlowchartConfigConstants';

export default function isFlowchartConfigVersionFullyAccessible(
  flowchartConfigVersion: ProcessFlowchartConfigVersionGraphQL
): flowchartConfigVersion is AccessibleFlowchartConfigVersion {
  if (flowchartConfigVersion.availableSchemas.some((schema) => isInaccessible(schema))) {
    return false;
  } else if (
    flowchartConfigVersion.schemaMapperConfigs.some(
      (mapperConfig) =>
        isInaccessible(mapperConfig.toSchema) ||
        mapperConfig.schemaFieldMapperConfigs.some(({fromSchema}) => isInaccessible(fromSchema))
    )
  ) {
    return false;
  }
  return true;
}
